/**
 * Event constants for observability logging.
 * Used with logOperationalEvent and logWarn from saddlebag-logger.
 */

export const COMPONENT = 'saddlebag-tracking-preferences';

// Lifecycle events
export const CMP_INITIALISED = 'CMP Initialised';
export const KETCH_SDK_LOADING = 'Ketch SDK Loading';
export const KETCH_SDK_LOADED = 'Ketch SDK Loaded';

// Consent operations
export const CONSENT_WRITE = 'Consent Write';

// Purpose-scoped ID service events
export const PURPOSE_SCOPED_ID_REFRESH_SUCCESS =
  'Purpose Scoped ID Refresh Success';
export const PURPOSE_SCOPED_ID_REFRESH_FAILURE =
  'Purpose Scoped ID Refresh Failure';
export const EXISTING_USER_MIGRATION_SUCCESS =
  'Existing User Migration Success';
export const NON_REGULATED_MARKET_TRACKING_SUCCESS =
  'Non Regulated Market Tracking Success';

// Ketch SDK load retry events
export const KETCH_SDK_LOAD_RETRY = 'Ketch SDK Load Retry';
export const KETCH_SDK_LOAD_RETRY_SUCCESS = 'Ketch SDK Load Retry Success';
export const KETCH_SDK_LOAD_RETRY_FAILURE = 'Ketch SDK Load Retry Failure';

// Failure events
export const KETCH_SDK_LOAD_FAILURE = 'Ketch SDK Load Failure';
export const CONSENT_COOKIE_PARSE_FAILURE = 'Consent Cookie Parse Failure';
export const CONSENT_PROPAGATION_FAILURE = 'Consent Propagation Failure';
export const KETCH_EVENT_BRIDGE_SETUP_FAILURE =
  'Ketch Event Bridge Setup Failure';
export const TCF_DATA_PARSE_FAILURE = 'TCF Data Parse Failure';
export const KETCH_API_TIMEOUT = 'Ketch API Timeout';

// Consent migration events (forward: gdpr → Ketch, reverse: Ketch → gdpr)
export const CONSENT_MIGRATION_FORWARD_ATTEMPTED =
  'Consent Migration Forward Attempted';
export const CONSENT_MIGRATION_FORWARD_SUCCESS =
  'Consent Migration Forward Success';
export const CONSENT_MIGRATION_FORWARD_SKIPPED =
  'Consent Migration Forward Skipped';
export const CONSENT_MIGRATION_FORWARD_FAILURE =
  'Consent Migration Forward Failure';
export const CONSENT_REVERSE_SYNC_SUCCESS = 'Consent Reverse Sync Success';
export const CONSENT_REVERSE_SYNC_SKIPPED = 'Consent Reverse Sync Skipped';
export const CONSENT_REVERSE_SYNC_FAILURE = 'Consent Reverse Sync Failure';

// tcString sync events
export const CONSENT_REVERSE_TCSTRING_SYNC_SUCCESS =
  'Consent Reverse tcString Sync Success';
export const CONSENT_REVERSE_TCSTRING_SYNC_FAILURE =
  'Consent Reverse tcString Sync Failure';
export const CONSENT_MIGRATION_FORWARD_TCF_PURPOSES_WIDENED =
  'Consent Migration Forward TCF Purposes Widened';
export const CONSENT_MIGRATION_FORWARD_TCSTRING_DECODE_FAILURE =
  'Consent Migration Forward tcString Decode Failure';
export const CONSENT_MIGRATION_FORWARD_VENDORS_FORWARDED =
  'Consent Migration Forward Vendors Forwarded';

// Consent ID resolve events
export const CONSENT_ID_RESOLVE_SUCCESS = 'Consent ID Resolve Success';
export const CONSENT_ID_RESOLVE_RETRY = 'Consent ID Resolve Retry';
export const CONSENT_ID_RESOLVE_FAILURE = 'Consent ID Resolve Failure';
export const CONSENT_ID_RESOLVE_RETRY_SUCCESS =
  'Consent ID Resolve Retry Success';
export const CONSENT_ID_RESOLVE_RETRY_FAILURE =
  'Consent ID Resolve Retry Failure';

// Error messages (thrown to consumers)
export const KETCH_SDK_NOT_LOADED_ERROR =
  'Ketch SDK not loaded. Call loadCMPSDK first.';

export function ketchModeRequiredError(fnName: string): string {
  return `[${COMPONENT}] ${fnName} requires Ketch CMP mode`;
}
